import { render, staticRenderFns } from "./dialogRoleListGroup.vue?vue&type=template&id=0f67933f&scoped=true"
import script from "./dialogRoleListGroup.vue?vue&type=script&lang=js"
export * from "./dialogRoleListGroup.vue?vue&type=script&lang=js"
import style0 from "./dialogRoleListGroup.vue?vue&type=style&index=0&id=0f67933f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f67933f",
  null
  
)

export default component.exports